import RestStatus from "http-status-codes";
import { apiUrl, HTTP_METHODS } from "../../helpers/constants";
import { message as messageInfo } from "antd";

const actionDescriptors = {
  resetMessage: "RESET_MESSAGE",
  setMessage: "SET_MESSAGE",
  getProperties: "get_properties",
  getPropertiesSuccessful: "GET_PROPERTIES_SUCCESSFUL",
  getPropertiesFailed: "GET_PROPERTIES_FAILED",
  getProperty: "GET_PROPERTY",
  getPropertySuccessful: "GET_PROPERTY_SUCCESSFUL",
  getPropertyFailed: "GET_PROPERTY_FAILED",
  postContact: "POST_CONTACT",
  postContactSuccessful: "POST_CONTACT_SUCCESSFUL",
  postContactFailed: "POST_CONTACT_FAILED",
  postNewsletterContact: "POST_NEWSLETTER_CONTACT",
  postNewsletterContactSuccessful: "POST_NEWSLETTER_CONTACT_SUCCESSFUL",
  postNewsletterContactFailed: "POST_NEWSLETTER_CONTACT_FAILED",
  postReview: "POST_REVIEW",
  postReviewSuccessful: "POST_REVIEW_SUCCESSFUL",
  postReviewFailed: "POST_REVIEW_FAILED",
  getReviews: "GET_REVIEWS",
  getReviewsSuccessful: "GET_REVIEWS_SUCCESSFUL",
  getReviewsFailed: "GET_REVIEWS_FAILED",
};

const actions = {
  resetMessage: (dispatch) => {
    dispatch({ type: actionDescriptors.resetMessage });
  },

  setMessage: (dispatch, message, success = false) => {
    dispatch({ type: actionDescriptors.setMessage, message, success });
  },

  getProperties: async (dispatch) => {
    dispatch({ type: actionDescriptors.getProperties });
    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_TABLE_ID}`, {
        method: HTTP_METHODS.GET,
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
      });

      const body = await response.json();
      console.log('body', body)
      const filteredBody = body.records.filter(record => record.fields.Active === true)
      console.log('filteredBody', filteredBody)
      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.getPropertiesSuccessful,
          payload: filteredBody,
        });
        actions.setMessage(dispatch, "Fetched properties successfully", true)
        return true;
      }

      dispatch({ type: actionDescriptors.getPropertiesFailed, error: 'Error while fetching properties' });
      actions.setMessage(dispatch, "Error while fetching properties")
      return false;

    } catch (error) {
      dispatch({ type: actionDescriptors.getPropertiesFailed, error: "Error while fetching properties" });
      actions.setMessage(dispatch, "Error while fetching properties")
    }
  },

  getProperty: async (dispatch, id) => {
    dispatch({ type: actionDescriptors.getProperty });
    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_TABLE_ID}/${id}`, {
        method: HTTP_METHODS.GET,
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
      });

      const body = await response.json();

      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.getPropertySuccessful,
          payload: body,
        });
        actions.setMessage(dispatch, "Fetched property successfully", true)
        return true;
      }

      dispatch({ type: actionDescriptors.getPropertyFailed, error: 'Error while fetching property' });
      actions.setMessage(dispatch, "Error while fetching property")
      return false;

    } catch (error) {
      dispatch({ type: actionDescriptors.getPropertyFailed, error: "Error while fetching property" });
      actions.setMessage(dispatch, "Error while fetching property")
    }
  },

  postContact: async (dispatch, payload) => {
    dispatch({ type: actionDescriptors.postContact });

    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_CONTACT_TABLE_ID}/`, {
        method: HTTP_METHODS.POST,
        credentials: "same-origin",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
        body: JSON.stringify(payload)
      });

      const body = await response.json();

      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.postContactSuccessful,
          payload: body.data,
        });
        actions.setMessage(dispatch, "thank you for submitting contact information", true)
        return true
      }
      dispatch({ type: actionDescriptors.postContactFailed, error: 'Error while submitting contact info' });
      actions.setMessage(dispatch, 'Error while submitting contact info')
      return false
    } catch (err) {
      dispatch({ type: actionDescriptors.postContactFailed, error: 'Error while submitting contact info' });
      actions.setMessage(dispatch, 'Error while submitting contact info')
    }
  },

  postNewsletterContact: async (dispatch, payload) => {
    dispatch({ type: actionDescriptors.postNewsletterContact });

    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_NEWSLETTER_TABLE_ID}/`, {
        method: HTTP_METHODS.POST,
        credentials: "same-origin",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
        body: JSON.stringify(payload)
      });

      const body = await response.json();

      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.postNewsletterContactSuccessful,
          payload: body.data,
        });
        const successMessage = "thank you for submitting contact information"
        actions.setMessage(dispatch, successMessage, true)
        messageInfo.success(successMessage);
        return true
      }
      const errorMessage = 'Error while submitting contact info';
      dispatch({ type: actionDescriptors.postNewsletterContactFailed, error: errorMessage });
      actions.setMessage(dispatch, errorMessage)
      messageInfo.error(errorMessage);
      return false
    } catch (err) {
      const errorMessage = 'Error while submitting contact info'
      dispatch({ type: actionDescriptors.postNewsletterContactFailed, error: errorMessage });
      actions.setMessage(dispatch, errorMessage)
      messageInfo.error(errorMessage);
    }

  },

  postReview: async (dispatch, payload) => {
    dispatch({ type: actionDescriptors.postReview });

    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_REVIEWS_TABLE_ID}/`, {
        method: HTTP_METHODS.POST,
        credentials: "same-origin",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
        body: JSON.stringify(payload)
      });

      const body = await response.json();

      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.postReviewSuccessful,
          payload: body.data,
        });
        actions.setMessage(dispatch, "thank you for submitting review", true)
        return true
      }
      dispatch({ type: actionDescriptors.postContactFailed, error: 'Error while submitting review' });
      actions.setMessage(dispatch, 'Error while submitting review')
      return false
    } catch (err) {
      dispatch({ type: actionDescriptors.postReviewFailed, error: 'Error while submitting review' });
      actions.setMessage(dispatch, 'Error while submitting review')
    }
  },
  getReviews: async (dispatch, propertyId) => {
    dispatch({ type: actionDescriptors.getReviews });

    try {
      const response = await fetch(`${apiUrl}/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_REVIEWS_TABLE_ID}/`, {
        method: HTTP_METHODS.GET,
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        },
      });

      const body = await response.json();

      const filteredBody = body.records.filter(record => record.fields.propertyId === propertyId)

      if (response.status === RestStatus.OK) {
        dispatch({
          type: actionDescriptors.getReviewsSuccessful,
          payload: filteredBody,
        });
        actions.setMessage(dispatch, "thank you for submitting review", true)
        return true
      }
      dispatch({ type: actionDescriptors.getReviewsFailed, error: 'Error while fetching reviews' });
      actions.setMessage(dispatch, 'Error while fetching reviews')
      return false
    } catch (err) {
      dispatch({ type: actionDescriptors.getReviewsFailed, error: 'Error while fetching reviews' });
      actions.setMessage(dispatch, 'Error while fetching reviews')
    }
  },
}

export { actionDescriptors, actions };